function ResumeButton() {
  return (
    <a 
      href="/Resume.pdf" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="btn btn-primary" // Add your CSS class here
    >
      Resume
    </a>
  );
}

export default ResumeButton;